module.exports = __webpack_public_path__ + "img/RIREKI_BLONDZ.81c4d6e0.png";